export default __webpack_public_path__ + "static/markedwax-84b687f95066102379476725ab4f554d.png";